import React, { useEffect, useState, useContext } from 'react'
import { i18nContext } from '../i18n/i18nContext';
import { KaguTop } from '../Pages/KaguTop';
import { KaguMailForm } from '../Pages/KaguMailForm';
import { KaguMailComplete } from '../Pages/KaguMailComplete';
import { KaguRefDataType, KaguRefForm } from '../Pages/KaguRefForm';
import { KaguRefInfo } from '../Pages/KaguRefInfo';
import { Processing } from '../Common/Processing';
import { ProcessError } from '../Common/ProcessError';
import { KaguRefNotReg } from '../Pages/KaguRefNotReg';

/**
 * ページ名オブジェクト
 * ページを指定するときに使用
 */
export const PageNames = {
    KaguTop: "KaguTop",
    KaguMailForm: "KaguMailForm",
    KaguMailComplete: "KaguMailComplete",
    KaguRefForm: "KaguRefForm",
    KaguRefInfo: "KaguRefInfo",
    KaguRefNotReg: "KaguRefNotReg",
    Processing: "Processing",
    ProcessError: "ProcessError"
}

/**
 * ブラウザのウインドウ名に表示する内容
 */
const PageTitles:{[pageName: string]: string} = {
    "KaguTop":"KAGUデザインコンペ 登録",
    "KaguMailForm":"KAGUデザインコンペ メールアドレス 入力フォーム",
    "KaguMailComplete":"KAGUデザインコンペ メールアドレス 登録完了",
    "KaguRefForm":"KAGUデザインコンペ 登録情報確認 入力フォーム",
    "KaguRefInfo":"KAGUデザインコンペ 登録情報",
    "KaguRefNotReg":"KAGUデザインコンペ 未登録",
    "Processing":"処理中",
    "ProcessError":"通信エラー",
}

/**
 * ページContextの型
 */
type PageContextType = {
    setPage: (page: string) => void,
    page: string,
}

/**
 * ページContextページ名、ページ変更関数を各ページに渡す
 */
export const PageContext = React.createContext<PageContextType>({} as PageContextType)

/**
 * メール登録、登録情報確認Root関数
 * ここから各ページに分岐する
 */
export function HomeTopMailConfirm() {

    const {setLng} = useContext(i18nContext);

    const [page, setPage] = useState<string>(PageNames.KaguTop);

    const [kaguRefData, setKaguRefData] = useState<KaguRefDataType | undefined>(undefined);

    const Pages: Record<string, JSX.Element> = {
        "KaguTop": <KaguTop/>,
        "KaguMailForm": <KaguMailForm/>,
        "KaguMailComplete": <KaguMailComplete/>,
        "KaguRefForm": <KaguRefForm setKaguRefData={setKaguRefData}/>,
        "KaguRefInfo": <KaguRefInfo kaguRefData={kaguRefData}/>,
        "KaguRefNotReg": <KaguRefNotReg/>,
        "Processing": <Processing/>,
        "ProcessError": <ProcessError pageName={PageNames.KaguTop} setPage={setPage}/>
    }

    useEffect(() => {
        var lng = new URLSearchParams(window.location.search).get("lng")

        if (lng === "ja" || lng === "en") {
            setLng(lng)
        } else {
            setLng("ja")
        }
    },[setLng])

    /**
     * ページ変更時処理
     */
    useEffect(() => {
        //ページタイトル変更
        document.title = PageTitles[page];
        //スクロール位置を一番上に戻す
        window.scrollTo(0, 0);
    },[page])

    return(
        <>
            <PageContext.Provider value={{page, setPage}}>
                {Pages[page]}
            </PageContext.Provider>
        </>
    );
}